module.exports = __webpack_public_path__ + "c3b30a4994e5a81c42ee3031225ca683.png";